import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, Mail, MessageCircle, Phone } from "lucide-react";
import Seo from "@/components/Seo";

export default function BookingConfirmed() {
  const { id } = useParams();
  const [b, setB] = useState(null);
  useEffect(() => { api.get(`/bookings/${id}`).then((r) => setB(r.data)); }, [id]);

  if (!b) return <div className="container-bl py-20">Loading…</div>;

  return (
    <div className="container-bl py-14 max-w-3xl" data-testid="page-booking-confirmed">
      <Seo title={`Booking confirmed · ${b.vehicle_name}`} description="Your B&L Rentals booking is confirmed." />
      <div className="text-center">
        <div className="mx-auto h-16 w-16 rounded-full bg-green-100 grid place-items-center text-green-700">
          <CheckCircle2 size={32} />
        </div>
        <h1 className="mt-5 text-3xl md:text-4xl font-heading font-bold text-white">Booking confirmed</h1>
        <p className="mt-2 text-[#AEB9C9]">Confirmation #<span className="font-mono" data-testid="booking-id">{b.booking_id}</span></p>
      </div>

      <div className="mt-8 card-bl p-6 md:p-8">
        <div className="flex gap-5 items-start">
          {b.vehicle_image && <img src={b.vehicle_image} alt={b.vehicle_name} className="w-40 h-28 rounded-lg object-cover" />}
          <div>
            <div className="text-xs uppercase tracking-widest text-[#E2AB20] font-semibold">Confirmed</div>
            <h2 className="mt-1 font-heading font-semibold text-xl">{b.vehicle_name}</h2>
            <div className="mt-2 text-sm text-[#AEB9C9]">
              <div>Pickup: <b>{b.start_date}</b></div>
              <div>Return: <b>{b.end_date}</b></div>
              <div>{b.days} day{b.days > 1 ? "s" : ""}</div>
            </div>
          </div>
        </div>
        <div className="mt-6 border-t pt-4 grid grid-cols-2 gap-3 text-sm">
          <div className="text-[#AEB9C9]">Subtotal</div><div className="text-right">${b.subtotal?.toFixed(2)}</div>
          {b.tier_label && b.tier_discount > 0 && (
            <><div className="text-green-700">{b.tier_label} ({Math.round((b.tier_discount_pct || 0) * 100)}% off)</div><div className="text-right text-green-700">-${b.tier_discount?.toFixed(2)}</div></>
          )}
          <div className="text-[#AEB9C9]">Unlimited miles</div><div className="text-right">Included</div>
          <div className="text-[#AEB9C9]">Fuel / charge</div><div className="text-right">Return same level</div>
          {b.discount > 0 && <><div className="text-green-700">Referral discount</div><div className="text-right text-green-700">-${b.discount?.toFixed(2)}</div></>}
          <div className="text-[#AEB9C9]">Taxes</div><div className="text-right">${b.taxes?.toFixed(2)}</div>
          <div className="font-bold">Total charged</div><div className="text-right font-bold">${b.total?.toFixed(2)}</div>
        </div>
        {b.total_savings > 0 && (
          <div className="mt-4 rounded-lg bg-green-50 border border-green-200 p-4 text-sm text-green-800" data-testid="conf-savings">
            <div className="font-semibold">You saved ${b.total_savings?.toFixed(2)} on this booking.</div>
            <div className="mt-0.5 text-xs">Effective rate: <b>${b.effective_per_day?.toFixed(2)}/day</b> (normally ${b.price_per_day}/day)</div>
          </div>
        )}
        <div className="mt-6 rounded-lg bg-blue-50 border border-blue-100 text-sm text-blue-900 p-4">
          <div className="font-semibold flex items-center gap-2"><Mail size={14} /> Confirmation sent (MOCK)</div>
          <div className="mt-1">A confirmation email and SMS have been queued for <b>{b.guest_email}</b> and <b>{b.guest_phone}</b> with pickup instructions.</div>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
        <Link to="/dashboard" className="btn-secondary text-center" data-testid="go-dashboard">View my bookings</Link>
        <Link to="/messages" className="btn-primary" data-testid="go-support">
          <MessageCircle size={16} className="mr-2" /> Message support
        </Link>
      </div>

      <div className="mt-8 text-center text-xs text-[#AEB9C9] flex items-center justify-center gap-2">
        <Phone size={12} /> 24/7 support · <a href="tel:+18052908431" className="hover:text-[#E2AB20]">(805) 290-8431</a>
      </div>
    </div>
  );
}
